module.exports = __webpack_public_path__ + "static/sport/bgi-pc.85dee79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-pc.jpg
// module id = Ddo7
// module chunks = 0